import React, { useEffect, useState } from 'react';
import { Modal } from '../../../Common/ui-components';
import Button from '../../../Common/ui-components/Button';
import { useTranslation } from 'react-i18next';

const ErrorModal = ({ isOpenModal, setIsOpenModal, title, content, onClose }) => {
    const { t, i18n } = useTranslation();
    return (
        <Modal
            className="error-modal"
            showCloseButton={false}
            isOpen={isOpenModal}
            onClose={() => {
                setIsOpenModal(false);
                onClose?.()
            }}
        >
            <h3 className="error-modal-title">{title}</h3>
            <div className="error-modal-content">
                {content}
            </div>
            <Button
                className="error-modal-close"
                onClick={() => {
                    setIsOpenModal(false);
                    onClose?.()
                }}
            >
                {t('RS_CLOSE')}
            </Button>
        </Modal>
    );
};
export default ErrorModal;
